import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type PlatformInvitation, usePlatformInvitationsResource } from '../resources'

// `failed` is the catch-all, so an unnamed error still reaches the surface (NFR-A1).
export type PlatformInvitationRefusal = 'already_registered' | 'not_found' | 'failed'

export const usePlatformInvitationStore = defineStore('platformInvitation', () => {
  const { getPlatformInvitations, setPlatformInvitation, setPlatformInvitationRevoke } = usePlatformInvitationsResource()
  const invitations = ref<PlatformInvitation[]>([])
  const pending = ref(false)
  const refusal = ref<PlatformInvitationRefusal>()

  const load = async () => {
    const { data } = await getPlatformInvitations()
    invitations.value = data ?? []
  }

  const send = async (email: string) => {
    pending.value = true
    refusal.value = undefined
    try {
      const { error } = await setPlatformInvitation(email)
      if (error) {
        refusal.value = (error.value as { error?: PlatformInvitationRefusal })?.error ?? 'failed'
        return false
      }
      await load()
      return true
    } finally {
      pending.value = false
    }
  }

  const revoke = async (id: string) => {
    pending.value = true
    refusal.value = undefined
    try {
      const { error } = await setPlatformInvitationRevoke(id)
      if (error) {
        refusal.value = (error.value as { error?: PlatformInvitationRefusal })?.error ?? 'failed'
        return
      }
      await load()
    } finally {
      pending.value = false
    }
  }

  return { invitations, pending, refusal, load, send, revoke }
})
